import { flowMedicationRequestService } from "@/services/notification/PostFlowMedicationRequest";
import { flowServiceRequestService } from "@/services/notification/PostFlowServiceRequest";

import type { PostAttendanceFollowUpType } from "../hooks/usePostAttendanceFollowUpSendDialog";

export interface SendPostAttendanceFluxmedFollowUpParams {
  row: any;
  type: PostAttendanceFollowUpType;
  /** Bundle de ServiceRequest — necessário para envio direto de exames. */
  exames?: any;
}

/**
 * Envio direto pelo número Fluxmed padrão (API legada de flows).
 * Não abre o modal de seleção de template.
 */
export async function sendPostAttendanceFluxmedFollowUp({
  row,
  type,
  exames,
}: SendPostAttendanceFluxmedFollowUpParams): Promise<void> {
  if (type === "medication") {
    const medicationRequestId = row?.medicationRequest?.id;
    if (!medicationRequestId) {
      throw new Error("ID do medicamento não encontrado");
    }

    await flowMedicationRequestService.sendFlow(medicationRequestId);
    return;
  }

  const serviceRequests = exames?.[0]?.entry?.filter((request: any) => {
    const findRef = row?.fullResource?.basedOn?.find((basedOn: any) =>
      basedOn?.reference.includes(request.resource.id),
    );
    return findRef;
  });

  if (!serviceRequests?.length) {
    throw new Error("Nenhum exame relacionado encontrado para envio");
  }

  for (const serviceRequest of serviceRequests) {
    await flowServiceRequestService.sendFlow(serviceRequest.resource.id);
  }
}
